/* レスポンシブ設定（374以下で崩れないように） */
const viewport = document.querySelector('meta[name="viewport"]');
export function switchViewport() {
  const value = window.outerWidth > 375 ? "width=device-width,initial-scale=1" : "width=375";
  if (viewport.getAttribute("content") !== value) {
    viewport.setAttribute("content", value);
  }
}
